interface DescriptionManagerProps<Field> {
    fieldMappings: Record<string, IDescriptionFieldMapping<Field>>
    record: Field
    globalFormatField?: (field) => any
    renderItem?: (field, value) => any
    groups?: Record<string, string>;

    dateFields?:string[],
    dateFormatter?:(date)=>string,
}

export default class DescriptionManager<Field> {

    fieldMappings: Record<string, IDescriptionFieldMapping<Field>> = {};
    record: Field;
    globalFormatField: (field) => any;
    renderItem: (field, value) => any;
    dateFields = [];
    dateFormatter;

    constructor(props: DescriptionManagerProps<Field>){
        Object.keys(props).forEach(key => this[key] = props[key]);
    }

    get fields() {
        return Object.keys(this.record);
    }

    getFieldDisplay(field) {
        if (this.fieldMappings[field]?.titleDisplay) {
            return this.fieldMappings[field].titleDisplay;
        } else if (this.globalFormatField) {
            return this.globalFormatField(field);
        } else {
            return field;
        }
    }

    getFieldValueRender(field) {
        let fieldValue = this.record[field];
        if (fieldValue) {
            if (this.fieldMappings[field]?.render) {
                return this.fieldMappings[field].render(fieldValue, this.record);
            } else if (this.dateFields.indexOf(field) !== -1 && this.dateFormatter) {
                return this.dateFormatter(fieldValue)
            } else {
                return fieldValue;
            }
        } else {
            return "N/A";
        }
    }

    renderItems() {
        return this.fields.map(field => {
            let fieldDisplay = this.getFieldDisplay(field);
            let renderValue = this.getFieldValueRender(field);
            if (this.fieldMappings[field]?.hide === true){
                return null;
            } else {
                return this.renderItem(fieldDisplay, renderValue);
            }
        })
    }
}

export interface IDescriptionFieldMapping<T> {
    titleDisplay?: string,
    render?: (fieldValue, record:T) => any,
    hide?:boolean
    group?:string,
}